<template>
	<b-modal
		hide-footer
		hide-header
		id="reportModal"
		modal-class="bottom-modal"
		v-model="showModal"
		no-close-on-backdrop
		@hidden="$emit('closeReport')"
	>
		<div>
			<div
				class="candash-reume-header d-flex align-items-center justify-content-between px-4 py-3"
			>
				Reasons for report
				<img
					@click="$emit('closeReport')"
					class="rotate-on-hover pointer"
					src="@/assets/newdesign/dashboard/blueCross.svg"
					alt=""
				/>
			</div>
			<div class="px-4 py-3">
				<Select
					label="Reason"
					:options="toDropdownOptions(reportIssue)"
					:selected="ticket.title"
					@update:selected="ticket.title = $event"
				/>
				<section class="p-1 d-flex flex-column gap-1 mt-2">
					<div class="fam-mont fw-LM fs-13 text-344054">
						Remarks<span class="asterik">*</span>
					</div>

					<b-form-textarea
						v-model="ticket.remarks"
						placeholder="Enter"
						class="giveFdbk-textarea w-100"
						:class="{ error: $v.ticket.remarks.$error }"
						rows="3"
						no-resize
					></b-form-textarea>
					<small v-if="$v.ticket.remarks.$error" class="candash-errortxt">
						Required.
					</small>
				</section>
			</div>
			<div class="mobjd-applied-footer justify-content-end w-100 px-4 py-3">
				<div class="mob-cancelBtn">
					<b-button @click="$emit('closeReport')">Cancel</b-button>
				</div>
				<div class="mob-addBtn position-relative">
					<b-button @click="submitReport(isTransaction)" class="px-4"
						>Report</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { raiseATicket, raiseReport } from "@/utils/apiFunctions";
import Select from "@/components/Filter/Select.vue";
import toast from "../mixin/toast";
import { required } from "vuelidate/lib/validators";

export default {
	mixins: [toast],
	data() {
		return {
			openModal: this.showModal,
			ticket: {
				category: "5",
				module: "3",
				referenceID: this.interviewId,
				createdByType: "1",
				remarks: "",
				title: "1",
			},
		};
	},
	props: {
		isCommon: {
			type: Boolean,
			default: false,
		},
		isTransaction: {
			type: Boolean,
			default: false,
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		interviewId: {
			type: String,
			default: null,
		},
		reportIssue: {
			type: Object,
			required: false,
		},
	},
	components: {
		Select,
	},
	validations() {
		return {
			ticket: {
				remarks: { required },
			},
		};
	},
	methods: {
		toDropdownOptions(options) {
			if (Array.isArray(options)) {
				return options.map((option) => ({
					value: option,
					text: option,
				}));
			} else {
				return Object.keys(options).map((key) => ({
					value: key,
					text: options[key],
				}));
			}
		},
		async submitReport(isTransaction = false) {
			try {
				this.$v.ticket.$touch();
				if (!this.$v.$invalid) {
					console.log("it is gere");
					let payload = {};
					if (isTransaction || this.isCommon) {
						console.log("created by type");
						payload = {
							category: isTransaction ? "10" : "11",
							module: isTransaction ? this.ticket.module : "5",
							referenceID: this.ticket.referenceID,
							createdByType: isTransaction ? "3" : "1",
							remarks: this.ticket.remarks,
							title: this.reportIssue[this.ticket.title],
						};
					} else {
						payload = {
							category: this.ticket.category,
							module: this.ticket.module,
							referenceID: this.ticket.referenceID,
							createdByType: this.ticket.createdByType,
							remarks: this.ticket.remarks,
							title: this.reportIssue[this.ticket.title], // This contains the selected option
						};
					}
					console.log("the payload", payload);
					let response;
					if (isTransaction || this.isCommon) {
						response = await raiseReport(payload);
					} else {
						response = await raiseATicket(payload);
					}
					if (response.status == 200) {
						this.$emit("updateReport");
						this.$emit("closeReport");
						this.$nextTick(() => {
							this.successModal(
								"Successfully reported.",
								"Issue is successfully reported."
							);
						});

						this.openModal = false;
						this.$v.$reset();
					} else {
						this.$nextTick(() => {
							this.errorModal("Error", "Already Reported");
						});
						this.$emit("closeReport");
					}
				}
			} catch (error) {
				console.log("the error", error);
				if (error.response.status == 403) {
					this.$nextTick(() => {
						this.errorModal("Error", "Already Reported");
					});
					this.$emit("closeReport");
				}
				console.error("Error submitting report:", error);
			}
		},
	},
};
</script>

<style>
.giveFdbk-textarea {
	border-radius: 8px;
	background: #fff;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #333333;
}
.giveFdbk-textarea.form-control:focus {
	box-shadow: none !important;
}
</style>
